import Select from "simple-custom-select"

let $select = document.getElementsByClassName('select')[0];

if($select) {
    window.select = new Select({
        $select: $select,
    });
}